import { transport } from 'config/transport';

export function callApiExportThuChiCTPV(congDoanId, year, month) {
    return transport.get(`/ctpv/thuchi/congDoan/${congDoanId}/exportReport`, { params: { year, month }, responseType: 'blob' });
}
